<template>
  <div>
    <div class="d-flex align-items-center justify-content-center" v-if="loadingQuest">
      <strong>Loading...</strong>
      <b-spinner type="grow" variant="secondary" class="mx-auto"></b-spinner>
    </div>
    <!-- <b-spinner type="grow" variant="secondary" center label="Loading..."></b-spinner> -->

    <div class="pt-3" v-if="questionario !=null">
      <h3 class="text-left text-secondary">{{questionario.nome}}</h3>
      <br />
      <div>
        <div
          v-for="(domanda,ind) in questionario.questionario"
          :key="ind"
          class="bg-grey px-1 py-2 mb-2"
        >
          <p class="font-italic text-font-grey">{{domanda.q}}</p>
          <p v-if="domanda.o !== 'file'" class="font-weight-bold">{{domanda.a}}</p>
          <div v-else>
            <span class="font-weight-bold">{{picLink == null ? getPic(domanda.a) : "" }}</span>
            <div
              v-if="picLink"
              @click="showPic"
              class="max__img col-4 mx-auto"
              :style="{ 'background-image': `url(${picLink})` }"
            ></div>
          </div>
        </div>
      </div>

      <!-- <p v-if="!questionario">Nessun questionario per questo consulto.</p> -->
      <b-modal
        ref="image"
        size="xl"
        title="Immagine"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white font-weight-bold"
        cancel-disabled
        ok-disabled
        ok-only
        id="primary__scroll"
      >
        <div class="d-100 text-center">
          <b-img :src="picLink" no-body class="text-center mx-auto" />
        </div>
      </b-modal>
    </div>
    <div v-else class="py-3">
      <p>nessun questionario per questo consulto</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "recap-questionario",
  props: ["consulto_rif"],
  data() {
    return {
      questionario: null,
      //   msgG: null,
      loadingQuest: true,
      picLink: null
    };
  },
  methods: {
    fetchData() {
      var url =
        process.env.VUE_APP_VERSION +
        "paziente/questionario?rif=" +
        this.consulto_rif;
      this.$axios
        .get(url)
        .then(res => {
          this.questionario = res.data.data;
          this.loadingQuest = false;
          //   if (res.data.data === null) {
          //     this.msgG = "nessun questionario per questo consulto";
          //   }
        })
        .catch(err => {
          console.log(err);

          this.loadingQuest = false;
        });
    },
    getPic(path) {
      //   this.loadingQuest = true;
      if (path && path.ext) {
        var url = process.env.VUE_APP_VERSION + "storage/questionario/img/get";
        var data = { img: path.path, ext: path.ext };
        // , { responseType: "blob" }
        this.$axios
          .post(url, data, { responseType: "arraybuffer" })
          .then(res => {
            this.picLink = window.URL.createObjectURL(new Blob([res.data]));
          })
          .catch(err => {
            console.log(err);

            this.loadingQuest = false;
          });
        return "";
      } else {
        return "nessuna immagine per questo questionario";
      }
    },
    showPic() {
      this.$refs["image"].show();
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
<style >
.max__img {
  min-height: 200px;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 2px solid transparent;
  border-radius: 3px;
  cursor: zoom-in;
  cursor: -webkit-zoom-in;
}
.max__img:hover {
  border: 2px solid #24b98c;
}
.hide {
  visibility: hidden;
}
.modal-footer {
  display: none;
}
</style>